import { DialogStateReturn } from "reakit"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faBullseyeArrow,
  faBadgeDollar,
  faScaleUnbalanced,
} from "@fortawesome/pro-duotone-svg-icons"

import { Modal } from "../../components/Modal"

export interface GowWizardHowDoIChooseModalProps {
  dialog: DialogStateReturn
}

const GowWizardHowDoIChooseModal = ({
  dialog,
}: GowWizardHowDoIChooseModalProps) => {
  return (
    <Modal
      header=""
      aria-label="how do I choose"
      dialog={dialog}
      className="max-w-[1355px] p-6 max-h-full"
    >
      <h2 className="text-3xl text-center font-display font-medium leading-[124%] tracking-[0.6px]">
        How do I choose?
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-[106px] pb-[96px] sm:px-[96px] lg:px-10 xl:px-[96px] mt-13">
        <div>
          <div className="w-[98px] h-[98px] flex items-center justify-center mx-auto">
            <FontAwesomeIcon icon={faBullseyeArrow} size="4x" color="#2D8052" />
          </div>

          <h3 className="text-xl font-display font-medium leading-[140%] tracking-[0.4px]">
            Which goal do you want to focus on?
          </h3>

          <p className="text-base font-body leading-[140%] tracking-[0.32px] mt-8">
            If you want to increase earnings from your land, focus on your
            income goal. If you want to protect against disease or fires, select
            Forest Health.
          </p>

          <p className="text-base font-body leading-[140%] tracking-[0.32px] mt-3">
            <strong>Do this:</strong> It's okay if you can't make up your mind.
            Save all of them! You can revise your saved programs later.
          </p>
        </div>

        <div>
          <div className="w-[98px] h-[98px] flex items-center justify-center mx-auto">
            <FontAwesomeIcon icon={faBadgeDollar} size="4x" color="#2D8052" />
          </div>

          <h3 className="text-xl font-display font-medium leading-[140%] tracking-[0.4px]">
            What are your Financial constraints?
          </h3>

          <p className="text-base font-body leading-[140%] tracking-[0.32px] mt-8">
            NRCS practices have up front costs that pay you back only after
            completing contract implementation. Reimbursement rate is estimated
            to be about 70%.
          </p>

          <p className="text-base font-body leading-[140%] tracking-[0.32px] mt-3">
            <strong>Do this:</strong> Write down what you feel comfortable
            spending for later reimbursement after contract completion to help
            determine how many practices to take on.
          </p>
        </div>

        <div>
          <div className="w-[98px] h-[98px] flex items-center justify-center mx-auto">
            <FontAwesomeIcon
              icon={faScaleUnbalanced}
              size="4x"
              color="#2D8052"
            />
          </div>

          <h3 className="text-xl font-display font-medium leading-[140%] tracking-[0.4px]">
            How much effort and time do you want to invest?
          </h3>

          <p className="text-base font-body leading-[140%] tracking-[0.32px] mt-8">
            Practices can be easy or difficult to implement based on local
            contractor availability or your ability to do the work yourself.
            Decide your time investment and what you feel comfortable tackling.
          </p>

          <p className="text-base font-body leading-[140%] tracking-[0.32px] mt-3">
            <strong>Do this:</strong> Write down how many hours you feel
            comfortable investing per year. How much time up front are you
            willing to invest to get started? Share with your NRCS
            representative to ensure a successful contract setup.
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default GowWizardHowDoIChooseModal
